module.exports = __webpack_public_path__ + "img/E1 Dot Box Choice Up.0ee8af98.png";